import * as React from 'react';
import { Button, useDeviceType } from '@cian/ui-kit';
import { Controls } from '../../components/LandingPageV2/Controls';
import { FORM_ANCHOR } from '../RequestFormV2Container/constants/constants';

export const ContactsControls = () => {
  const device = useDeviceType();
  const buttonSize = device === 'desktop' ? 'L' : 'M';

  const handleClick = () => {
    const form = document.getElementById(FORM_ANCHOR);
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Controls>
      <Button data-testid="requestFormV2Button" size={buttonSize} theme="fill_primary" fullWidth onClick={handleClick}>
        Заполнить заявку
      </Button>
      <Button size={buttonSize} theme="fill_secondary" fullWidth>
        Позвонить консультанту
      </Button>
    </Controls>
  );
};
